import React, { useState, useRef, useEffect } from 'react';
import {
  Bell,
  Database,
  HelpCircle,
  LogOut,
  X,
  Settings,
  Hash,
  Eye,
  EyeOff
} from 'lucide-react';
import { useAnonymize } from '../contexts/AnonymizeContext';

export const BarraSuperior = ({
  menus = [],
  openTabs = [],
  activeMenu,
  setActiveMenu,
  fecharAba,
  themeMode,
  proximoTema,
  IconeTema,
  rotuloTema,
  abrirCentralAjuda,
  interfaceZoom,
  reduzirZoomInterface,
  aumentarZoomInterface,
  restaurarZoomInterface,
  notificacoesTopoAberto,
  setNotificacoesTopoAberto,
  orientacoesPendentesTopo = 0,
  sugestoesPendentesTopo = 0,
  notificacoesLista = [],
  abrirNotificacao,
  setModalLimpezaCacheAberto,
  handleLogout,
  user,
  obterIniciais,
  hideMenuNumbers: propHideMenuNumbers,
  toggleHideMenuNumbers: propToggleHideMenuNumbers
}) => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const { isAnonymized, toggleAnonymize, maskNome, maskEmail } = useAnonymize();

  const [localHideMenuNumbers, setLocalHideMenuNumbers] = useState(() => {
    return localStorage.getItem('apex_hide_menu_numbers') === 'true';
  });
  const currentHideMenuNumbers = propHideMenuNumbers !== undefined ? propHideMenuNumbers : localHideMenuNumbers;

  const onToggleHideMenuNumbers = () => {
    if (propToggleHideMenuNumbers) {
      propToggleHideMenuNumbers();
    } else {
      const next = !currentHideMenuNumbers;
      localStorage.setItem('apex_hide_menu_numbers', String(next));
      setLocalHideMenuNumbers(next);
      window.dispatchEvent(new CustomEvent('apex_hide_menu_numbers_changed', { detail: next }));
      window.dispatchEvent(new Event('storage'));
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    }
    if (userMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userMenuOpen]);

  const userPhoto = user?.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || user?.displayName || user?.email || 'U')}&background=f3e8ff&color=a21caf`;
  const totalNotificacoes = orientacoesPendentesTopo + sugestoesPendentesTopo;

  return (
    <header className="facil-top-header">
      <div className="facil-tabs-area custom-scrollbar">
        {openTabs.map(tab => {
          const menu = menus.find(item => item.id === tab.id);
          const ativa = activeMenu === tab.id;

          return (
            <div
              key={tab.id}
              className={
                ativa
                  ? 'facil-tab-item facil-tab-active'
                  : 'facil-tab-item'
              }
              style={{
                '--facil-tab-accent':
                  tab.tabColor || menu?.tabColor || '#2563eb'
              }}
            >
              <span
                className="facil-tab-dot"
                style={{
                  background:
                    tab.tabColor || menu?.tabColor || '#2563eb'
                }}
              />

              <button
                type="button"
                onClick={() => setActiveMenu(tab.id)}
                className="facil-tab-label"
              >
                {menu?.label || menu?.title || tab.label || tab.title}
              </button>

              <button
                type="button"
                onClick={() => fecharAba(tab.id)}
                className="facil-tab-close"
                title="Fechar aba"
              >
                <X size={12} />
              </button>
            </div>
          );
        })}
      </div>

      <div className="facil-top-header-right">
        <button
          onClick={() => setModalLimpezaCacheAberto(true)}
          className="facil-top-icon-btn"
          title="Limpar cache por módulo"
        >
          <Database size={15} />
        </button>

        <button
          onClick={proximoTema}
          className="facil-top-icon-btn"
          title={`Tema: ${rotuloTema}. Clique para alternar.`}
        >
          <IconeTema size={14} />
        </button>

        <button
          onClick={abrirCentralAjuda}
          className="facil-top-icon-btn facil-help-button"
          title="Ajuda, manual, sugestões e correções"
        >
          <HelpCircle size={17} strokeWidth={3} />
        </button>

        <div
          className="facil-ui-zoom"
          title="Tamanho geral do sistema"
        >
          <button
            type="button"
            onClick={reduzirZoomInterface}
            disabled={interfaceZoom <= 70}
            aria-label="Diminuir tamanho do sistema"
          >
            A-
          </button>

          <button
            type="button"
            onClick={restaurarZoomInterface}
            className="facil-ui-zoom-value"
            title="Restaurar para 100%"
          >
            {interfaceZoom}%
          </button>

          <button
            type="button"
            onClick={aumentarZoomInterface}
            disabled={interfaceZoom >= 130}
            aria-label="Aumentar tamanho do sistema"
          >
            A+
          </button>
        </div>

        <div className="facil-notification-wrapper">
          <button
            onClick={() =>
              setNotificacoesTopoAberto(valor => !valor)
            }
            className="facil-top-icon-btn facil-notification-button"
            title="Central de notificações"
          >
            <Bell size={14} />

            {totalNotificacoes > 0 && (
              <span className="facil-notification-badge">
                {totalNotificacoes}
              </span>
            )}
          </button>

          {notificacoesTopoAberto && (
            <div className="facil-notifications-panel custom-scrollbar">
              <div className="facil-notifications-title">
                <span>
                  <Bell size={15} /> Notificações
                </span>

                <button
                  type="button"
                  onClick={() =>
                    setNotificacoesTopoAberto(false)
                  }
                >
                  <X size={15} />
                </button>
              </div>

              {totalNotificacoes === 0 && (
                <div className="facil-notifications-empty">
                  Nenhuma notificação pendente.
                </div>
              )}

              {notificacoesLista.map(item => (
                <button
                  key={item.id}
                  type="button"
                  className="facil-notification-item"
                  onClick={() => abrirNotificacao(item)}
                >
                  <strong>{item.titulo}</strong>
                  <span>{item.mensagem}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          onClick={handleLogout}
          className="facil-top-icon-btn facil-logout-button"
          title="Sair"
        >
          <LogOut size={14} />
        </button>

        <div className="facil-user-summary relative" ref={userMenuRef}>
          <button
            type="button"
            onClick={() => setUserMenuOpen(prev => !prev)}
            className="focus:outline-none flex items-center p-0.5 rounded-full hover:ring-2 hover:ring-blue-500/50 transition-all cursor-pointer"
            title="Perfil e Configurações"
          >
            <img
              src={userPhoto}
              alt={user?.name || 'Usuário'}
              className="facil-user-photo"
              referrerPolicy="no-referrer"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || user?.displayName || user?.email || 'U')}&background=f3e8ff&color=a21caf`;
              }}
            />
          </button>

          <div 
            className="facil-user-name-wrapper cursor-pointer select-none"
            onClick={() => setUserMenuOpen(prev => !prev)}
            title="Perfil e Configurações"
          >
            <span className="facil-user-name">
              {isAnonymized ? maskNome(user?.name || user?.email || 'Usuário') : (user?.name || user?.email || 'Usuário')}
            </span>
          </div>

          {/* MENU DO USUÁRIO FLUTUANTE (POPOVER) */}
          {userMenuOpen && (
            <div className="facil-user-menu-popover absolute right-0 top-11 min-w-[270px] rounded-xl shadow-2xl p-3 z-[150] animate-in fade-in slide-in-from-top-2 duration-200 flex flex-col gap-2 text-left whitespace-nowrap">
              <div className="flex flex-col">
                <span className="text-xs font-black text-slate-800 dark:text-slate-200 truncate">
                  {isAnonymized ? maskNome(user?.name || user?.displayName || 'Usuário apEx') : (user?.name || user?.displayName || 'Usuário apEx')}
                </span>
                <span className="text-[10px] font-bold text-slate-500 truncate mt-0.5">
                  {isAnonymized ? maskEmail(user?.email || 'email@exemplo.com') : (user?.email || 'email@exemplo.com')}
                </span>
              </div>
              <div className="border-t border-slate-200 dark:border-slate-800/80 my-1" />

              {/* a) Config. conta Google */}
              <a
                href="https://myaccount.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="facil-user-menu-item w-full flex items-center justify-between gap-3 px-2.5 py-2 rounded-lg text-xs font-bold transition-colors cursor-pointer"
                onClick={() => setUserMenuOpen(false)}
              >
                <span className="flex items-center gap-2.5">
                  <Settings size={14} className="shrink-0 text-slate-500 dark:text-slate-400" />
                  <span>Config. conta Google</span>
                </span>
              </a>

              {/* b) Ocultar números de Menus */}
              <button
                type="button"
                onClick={onToggleHideMenuNumbers}
                className="facil-user-menu-item w-full flex items-center justify-between gap-3 px-2.5 py-2 rounded-lg text-xs font-bold transition-colors cursor-pointer"
                title="Ocultar ou exibir os números dos menus e submenus"
              >
                <span className="flex items-center gap-2.5">
                  <Hash size={14} className={currentHideMenuNumbers ? "text-amber-500 shrink-0" : "text-slate-500 dark:text-slate-400 shrink-0"} />
                  <span>Ocultar números de Menus</span>
                </span>
                <div 
                  className={`facil-user-toggle-track ${
                    currentHideMenuNumbers ? "facil-toggle-on" : "facil-toggle-off"
                  }`}
                >
                  <div className="facil-user-toggle-thumb" />
                </div>
              </button>

              {/* c) Anonimizar dados */}
              <button
                type="button"
                onClick={toggleAnonymize}
                className="facil-user-menu-item w-full flex items-center justify-between gap-3 px-2.5 py-2 rounded-lg text-xs font-bold transition-colors cursor-pointer"
                title="Ativar/Desativar Anonimização de Dados nas telas"
              >
                <span className="flex items-center gap-2.5">
                  {isAnonymized ? <EyeOff size={14} className="text-amber-500 shrink-0" /> : <Eye size={14} className="text-blue-500 shrink-0" />}
                  <span>Anonimizar dados</span>
                </span>
                <div 
                  className={`facil-user-toggle-track ${
                    isAnonymized ? "facil-toggle-on" : "facil-toggle-off"
                  }`}
                >
                  <div className="facil-user-toggle-thumb" />
                </div>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default BarraSuperior;
